const baseClass = "js-cta",
  selectors = {
    BASE: `.${baseClass}`,
    WRAPPER: `.${baseClass}-wrapper`,
  };

function initIntersectionObserver() {
  const cta = document.querySelector(".cta");
  const ctaWrapper = document.querySelector(".cta-wrapper");

  const wrapperHeight =
    parseFloat(window.getComputedStyle(ctaWrapper).marginBottom) +
    ctaWrapper.offsetHeight;

  const observer = new IntersectionObserver(
    ([entry]) => {
      const triggerTop = entry.boundingClientRect.top;
      const windowHeight = window.innerHeight;
      const isTriggerAboveViewport = triggerTop < windowHeight;

      if (!entry.isIntersecting) {
        if (isTriggerAboveViewport) {
          cta.classList.add("is-fixed");
        }
      } else if (isTriggerAboveViewport && triggerTop > 0) {
        cta.classList.remove("is-fixed");
      }
    },
    {
      threshold: 0,
      rootMargin: `-${wrapperHeight}px 0px 0px 0px`,
    },
  );

  observer.observe(ctaWrapper);
}

class Cta {
  /**
   * Creates an instance of Menu.
   *
   * @param {HTMLElement} [baseElement=document.querySelector(selectors.BASE)]
   * @memberof Cta
   */
  constructor(baseElement = document.querySelector(selectors.BASE)) {
    if (baseElement === null) {
      return;
    }

    initIntersectionObserver.call(this);
  }

  /**
   *
   * @type {HTMLElement}
   * @memberof Cta
   */
  get baseElement() {
    return this._baseElement;
  }
  set baseElement(value) {
    this._baseElement = value;
  }
}

function init() {
  new Cta();
}

init();

export default Cta;
